const e = { "logged-ticket-private": "{{name}} ha registrato questo", view: "Visualizza", "view-ticket": "Visualizza ticket", meeting: "Incontro", "shared-private": "{{name}} ha condiviso questo", "logged-ticket-public": "{{name}} ha registrato questo", "shared-public": "{{name}} ha registrato questo", "crated-meeting-public": "{{name}} ha condiviso un incontro", "crated-meeting-private": "{{name}} ha creato un incontro" }, t = { ticketing: "Emissione di biglietti", messaging: "Messaggistica" }, i = {
  link: e,
  category: t
};
export {
  t as category,
  i as default,
  e as link
};
